export default import.meta.ROLLDOWN_FILE_URL_OEnYfcMIk4zZrHiizmY4yQ